import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import StarRating from "./StarRating";
import "./StarRating.css";
import "../Review/Review.css";

export interface TextBoxProps {
    picture?: string;
    username: string;
    content: string;
    createdAt: string;
    updatedAt?: string;
    linkTo?: string;
    rating?: number;
    isOwner?: boolean;
    onEdit?: () => void;
    headerActions?: ReactNode;
    defaultAvatar?: string;
    userId?: number;
}

const TextBox: React.FC<TextBoxProps> = ({
    picture,
    username,
    content,
    createdAt,
    updatedAt,
    linkTo,
    rating,
    isOwner = false,
    onEdit,
    headerActions,
    defaultAvatar = "/dubuFace.jpg",
    userId,
}) => {
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="review-item">
            <div className="review-header">
                <div className="reviewer-info">
                    <div className="reviewer-info-wrapper">
                        {username && userId ? (
                            <Link to={`/user/${username}`} className="reviewer-link">
                                <img
                                    src={picture || defaultAvatar}
                                    alt={username}
                                    className="reviewer-avatar"
                                    onError={(e) => {
                                        e.currentTarget.src = defaultAvatar;
                                        e.currentTarget.onerror = null;
                                    }}
                                />
                                <div className="reviewer-details">
                                    <span className="reviewer-name">{username}</span>
                                    <div className="review-date">
                                        {updatedAt && updatedAt !== createdAt
                                            ? `(edited) ${formatDate(updatedAt)}`
                                            : formatDate(createdAt)}
                                    </div>
                                </div>
                            </Link>
                        ) : (
                            <>
                                <img
                                    src={picture || defaultAvatar}
                                    alt={username}
                                    className="reviewer-avatar"
                                    onError={(e) => {
                                        e.currentTarget.src = defaultAvatar;
                                        e.currentTarget.onerror = null;
                                    }}
                                />
                                <div className="reviewer-details">
                                    <div className="reviewer-name">{username}</div>
                                    <div className="review-date">
                                        {updatedAt && updatedAt !== createdAt
                                            ? `(edited) ${formatDate(updatedAt)}`
                                            : formatDate(createdAt)}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="review-actions">
                    {rating !== undefined && (
                        <div className="review-rating">
                            <span className="stars">
                                <StarRating rating={rating} size="small" />
                            </span>
                            <span className="rating-number">{rating.toFixed(1)}</span>
                        </div>
                    )}
                </div>
            </div>

            <div className="review-content">
                {content}
            </div>
            <div className="review-buttons">
                {isOwner && onEdit && (
                    <button
                        className="edit-review-button"
                        onClick={onEdit}
                        aria-label="Edit"
                    >
                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </button>
                )}
                {headerActions}
            </div>
        </div>
    );
};

export default TextBox; 